import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-300">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 py-14">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl" style={{ color: `oklch(var(--primary-400))` }}></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                韩漫之家
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-400">
              {siteInfo.tagline}。{siteInfo.description.slice(0, 60)}...
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
              <li>
                <span className="text-sm text-background-400">{siteInfo.email}</span>
              </li>
              <li>
                <span className="text-sm text-background-400">{siteInfo.phone}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫之家. 本站所有漫画内容均已获得版权方正式授权.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 hover:text-background-400 transition-colors cursor-pointer">隐私政策</span>
            <span className="text-xs text-background-500 hover:text-background-400 transition-colors cursor-pointer">服务条款</span>
            <span className="text-xs text-background-500 hover:text-background-400 transition-colors cursor-pointer">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}